import { useEffect, useState } from "react";
import { domain } from "config.js";
import { IoIosFunnel } from "react-icons/io";


import style from "./style.module.scss";
import Item from "./Item";


function SearchResults() {
    const [images, setImages] = useState();


    const items = [
        {
            "Man-1": {
                "description": "Ontdek het grootste project aan de Costa del Sol, tegen de laagste prijs.\n\nAppartementen met 2 en 3 slaapkamers die deel uitmaken van een prachtig resort met zwembaden en dromerige gemeenschappelijke ruimtes, vanaf slechts € 97.500 + btw, inclusief een eigen parkeerplaats.\n\n\nDeze geweldige ontwikkeling is al gebouwd met een geschatte einddatum voor het einde van het tweede kwartaal van 2021 ... wat wil nog meer?",
                "type": "Apartment",
                "price": 97500,
                "bedrooms": "2",
                "location": "Manilva",
                "region": "Costa del Sol"
            }
        },
        {
            "Cam-23": {
                "description": "Ontdek het grootste project aan de Costa del Sol, tegen de laagste prijs.\n\nAppartementen met 2 en 3 slaapkamers die deel uitmaken van een prachtig resort met zwembaden en dromerige gemeenschappelijke ruimtes, vanaf slechts € 97.500 + btw, inclusief een eigen parkeerplaats.\n\n\nDeze geweldige ontwikkeling is al gebouwd met een geschatte einddatum voor het einde van het tweede kwartaal van 2021 ... wat wil nog meer?",
                "type": "Villa",
                "price": 1015000,
                "bedrooms": "4",
                "location": "Campoamor",
                "region": "Costa Blanca Sud"
            }
        },
        {
            "Vil-85": {
                "description": "Ontdek het grootste project aan de Costa del Sol, tegen de laagste prijs.\n\nAppartementen met 2 en 3 slaapkamers die deel uitmaken van een prachtig resort met zwembaden en dromerige gemeenschappelijke ruimtes, vanaf slechts € 97.500 + btw, inclusief een eigen parkeerplaats.\n\n\nDeze geweldige ontwikkeling is al gebouwd met een geschatte einddatum voor het einde van het tweede kwartaal van 2021 ... wat wil nog meer?",
                "type": "House",
                "price": 6499000,
                "bedrooms": "1",
                "location": "Villajoyosa",
                "region": "Costa Blanca Nord"
            }
        },
        {
            "Cab-34": {
                "description": "Ontdek het grootste project aan de Costa del Sol, tegen de laagste prijs.\n\nAppartementen met 2 en 3 slaapkamers die deel uitmaken van een prachtig resort met zwembaden en dromerige gemeenschappelijke ruimtes, vanaf slechts € 97.500 + btw, inclusief een eigen parkeerplaats.\n\n\nDeze geweldige ontwikkeling is al gebouwd met een geschatte einddatum voor het einde van het tweede kwartaal van 2021 ... wat wil nog meer?",
                "type": "Apartment",
                "price": 875000,
                "bedrooms": "3",
                "location": "Cabo Palos",
                "region": "Costa Calida"
            }
        }
    ];

    return (
        <div className={style.root}>
            {
                // <div className="row no-gutters align-items-center">
                //     {/* <BackButton className="col-12 col-md-2 mt-3 mb-4" /> */}
                //     {/* <div>Back</div>
                // <h1 className="col search-result-title w-100 text-center">Search results</h1> */}
                //     <div className="col-12 col-md-4 col-lg-3 col-xl-2 search-result-sort d-flex flex-row align-items-center">
                //         <div className="d-flex align-items-center search-result-sort-icon-cnt">
                //             <IoIosFunnel size="20" className="search-result-sort-icon" />
                //         </div>
                //         <select className="form-control" onChange={e => {
                //             // changeQuery({ pricesort: e.target.value, offset: 0 });
                //         }}>
                //             something
                //             <option value="ascending">
                //                 laag naar hoog
                //             </option>
                //             <option value="descending">
                //                 hoog naar laag
                //             </option>
                //         </select>
                //     </div>
                // </div>
            }
            <div className={style.center}> 
                <div className={style.propertiesContainer}>
                    {items.map((item, i) => {
                        const key = Object.keys(item)[0];
                        return <Item data={item[key]} refNo={key} key={i} />
                    })}
                </div>
            </div>
        </div>
    );
}

export default SearchResults;